import { axiosInstance } from '@configs/axios/axiosInstance';

import type { Document } from '../types/document.types';
import type {
  GetDocumentsParams,
  GetDocumentsResult,
} from './getDocuments.types';

/**
 * Fetch documents for a given type and optional folder/search.
 * Endpoint: GET /documents
 *
 * `organizationId` is sent as the X-Organization-ID request header when provided.
 * Total count is returned via the `x-total-count` response header.
 */
export async function getDocuments(
  params: GetDocumentsParams
): Promise<GetDocumentsResult> {
  const { organizationId, ...queryParams } = params;

  const headers: Record<string, string> = {};
  if (organizationId) {
    headers['X-Organization-ID'] = organizationId;
  }

  const response = await axiosInstance.get<Document[]>('/documents', {
    params: queryParams,
    headers,
  });

  const totalCount = Number(response.headers['x-total-count']) || 0;

  return {
    documents: response.data,
    totalCount,
  };
}
